import { NewsletterSplitTestViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface'
import { SplitTestSettingsInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface'
import { TagListAllInterface } from 'modules/tags/types/tag-interface'
import { ContactsSettings } from 'shared/components/dashboard-mail-editor/components/contacts-settings-block'
import { useMailingState } from 'shared/components/dashboard-mail-editor/hooks/use-mailing-state'
import {
  AttachmentFileInterface,
  UnsavedAttachmentFileInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'
import { isAttachmentInterface } from 'shared/components/dashboard-mail-editor/utils/is-attachment-interface'

interface TransformToNewsletterWithSplitTestDataProps {
  variantA: ReturnType<typeof useMailingState>
  variantB: ReturnType<typeof useMailingState>
  newsletterData: NewsletterSplitTestViewApiInterface
  contactsSettings: ContactsSettings
  listOfTags: TagListAllInterface | undefined
  splitTestSettings: SplitTestSettingsInterface
  attachmentsTempStateVariantA: Array<UnsavedAttachmentFileInterface | AttachmentFileInterface>
  attachmentsTempStateVariantB: Array<UnsavedAttachmentFileInterface | AttachmentFileInterface>
}

export const transformToNewsletterWithSplitTestData = ({
  variantA,
  variantB,
  newsletterData,
  contactsSettings,
  listOfTags,
  splitTestSettings,
  attachmentsTempStateVariantA,
  attachmentsTempStateVariantB,
}: TransformToNewsletterWithSplitTestDataProps): NewsletterSplitTestViewApiInterface => {
  return {
    ...newsletterData,
    mailingSplitTest: {
      ...newsletterData.mailingSplitTest,
      mailingVariantA: {
        ...variantA.mailing,
        currentEmail: {
          ...variantA.mailing.currentEmail,
          ...variantA.tempState,
          attachments: attachmentsTempStateVariantA.filter(isAttachmentInterface),
        },
      },
      mailingVariantB: {
        ...variantB.mailing,
        currentEmail: {
          ...variantB.mailing.currentEmail,
          ...variantB.tempState,
          attachments: attachmentsTempStateVariantB.filter(isAttachmentInterface),
        },
      },
      settings: splitTestSettings,
    },
    tags: listOfTags?.items.filter(el => contactsSettings.tags.included.includes(el.id)) ?? [],
    excludedTags:
      listOfTags?.items.filter(el => contactsSettings.tags.excluded.includes(el.id)) ?? [],
    daysExists: contactsSettings.daysExists,
  }
}
